import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { SITE } from "../i18n/translations";

// items: [{label, to}] ; last item is current (no link)
export default function Breadcrumbs({ items = [] }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: `${SITE.domain}/` },
      ...items.map((it, i) => ({
        "@type": "ListItem",
        position: i + 2,
        name: it.label,
        item: it.to ? `${SITE.domain}${it.to}` : undefined,
      })),
    ],
  };

  return (
    <nav className="flex items-center flex-wrap gap-1.5 text-xs text-tara-muted mb-6" aria-label="Breadcrumb" data-testid="breadcrumbs">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <Link to="/" className="hover:text-tara-gold transition flex items-center gap-1">
        <Home className="h-3.5 w-3.5" />
      </Link>
      {items.map((it, i) => (
        <span key={i} className="flex items-center gap-1.5">
          <ChevronRight className="h-3.5 w-3.5 text-tara-muted/70" />
          {it.to ? (
            <Link to={it.to} className="hover:text-tara-gold transition">{it.label}</Link>
          ) : (
            <span className="text-tara-gold">{it.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
